export const stateTask = [
    { text: 'Новая', value: 0 },
    { text: 'Отправлена на точку', value: 1 },
    { text: 'Принята"', value: 2 },
    { text: 'Завершена', value: 3 },
    { text: 'Ошибка', value: 4 },
]
export const actionTask = [
    { text: 'Сверка итогов', value: 0 },
    { text: 'Отмена операции', value: 1 },
    { text: 'Запрос на реле', value: 2 },
    { text: 'Перезагрузка', value: 3 },
    { text: 'Обновление конфигурации', value: 4 },
    { text: 'Инициализация', value: 5 },
    { text: 'Активация', value: 6 },
    { text: 'Настройка сети', value: 7 },
    { text: 'Выдать товар на POS-точке', value: 8 },
    { text: 'Обновление параметров', value: 9 },
]
